<template>
  <div class="nav">
    <div class="nav--mobile">
      <div class="logo">TheGoldGem</div>
      <svg
        id="navLinks"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="48"
        height="48"
        viewBox="0 0 172 172"
        style=" fill:#000000;"
      >
        <g
          fill="none"
          fill-rule="nonzero"
          stroke="none"
          stroke-width="1"
          stroke-linecap="butt"
          stroke-linejoin="miter"
          stroke-miterlimit="10"
          stroke-dasharray=""
          stroke-dashoffset="0"
          font-family="none"
          font-weight="none"
          font-size="none"
          text-anchor="none"
          style="mix-blend-mode: normal"
        >
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g fill="#ffffff">
            <path
              d="M14.33333,35.83333v14.33333h143.33333v-14.33333zM14.33333,78.83333v14.33333h143.33333v-14.33333zM14.33333,121.83333v14.33333h143.33333v-14.33333z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
    <div class="logo" @click="goToRoute('Home')" v-if="!isMobile">
      TheGoldGem
    </div>
    <div class="nav__links" v-if="showMenu || !isMobile">
      <div @click="goToRoute('Home')">Home</div>
      <div @click="goToRoute('About')">About</div>
      <div @click="goToRoute('Recruitment')">Recruitment</div>
      <div @click="goToRoute('Contact')">Contact</div>
    </div>
  </div>
</template>

<script>
import logomain from "@/assets/logomain.png";
export default {
  name: "NavBar",
  data() {
    return {
      isMobile: false,
      showMenu: false,
      minWidth: 600,
      logo: logomain,
    };
  },
  mounted() {
    this.checkIsMobile();
  },
  methods: {
    goToRoute(name) {
      this.showMenu = false;
      this.$router.push({ name }).catch(() => {});
    },
    checkIsMobile() {
      const isMobile = /iPhone|iPad|iPod|Android|BlackBerry|webOS/i.test(
        navigator.userAgent
      );
      this.isMobile = isMobile;
      this.listen(window.innerWidth);
      const vm = this;
      window.addEventListener("resize", function(e) {
        vm.listen(e.target.innerWidth);
      });
      document.addEventListener("click", function(e) {
        vm.clicks(e);
      });
    },
    listen(width) {
      if (width <= this.minWidth) {
        this.isMobile = true;
        this.showMenu = false;
      } else {
        this.isMobile = false;
        this.showMenu = true;
      }
    },
    clicks(evt) {
      const flyoutElement = document.getElementById("navLinks");
      let targetElement = evt.target;

      do {
        if (targetElement == flyoutElement) {
          // This is a click inside. Do nothing, just return.
          this.showMenu = true;
          return;
        }
        // Go up the DOM
        targetElement = targetElement.parentNode;
      } while (targetElement);
      this.showMenu = false;
    },
  },
  beforeDestroy() {
    const vm = this;
    window.removeEventListener("resize", function(e) {
      vm.listen(e.target.innerWidth);
    });
    document.removeEventListener("click", function(e) {
      vm.clicks(e);
    });
  },
};
</script>

<style scoped>
.logo {
  margin-right: 30px;
  margin-left: 10px;
  cursor: pointer;
  padding: 10px;
  font-size: 25px;
  font-weight: 800;
}
.nav {
  background-color: #404c60;
  color: #ffffff;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #404c60;
  box-shadow: -1px 1px 13px 1px #404c60;
  position: fixed;
  width: 100%;
  z-index: 30;
  top: 0;
}
.nav__links {
  display: flex;
  transition: all 0.3s ease-in-out;
}
.nav__links div {
  margin-right: 10px;
  cursor: pointer;
  padding: 10px;
  font-size: 20px;
  font-weight: 600;
}
.nav--mobile {
  display: none;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (max-width: 600px) {
  .nav__links {
    display: block;
    background: white;
    width: 100%;
    color: #404c60;
    text-align: left;
    box-shadow: -1px 1px 13px 1px #404c60;
    transition: all 0.3s ease-in-out;
    height: 250px;
  }
  .nav {
    flex-direction: column;
    align-items: inherit;
  }
  .nav--mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
